export const enum IntegrationTemplateContactType {
	Contact = 0,
	ContactGroup = 1,
	Adhoc = 2
}